// @ts-nocheck

import CommonApi from './../commonApi';
import { convertFromHourToSecond, convertFromKmToM, convertFromMToKm, convertFromSecondToHour } from '../pure/unitConversions';
const convertDataToServer = regulationLimitGroup => ({
  ...regulationLimitGroup,
  hours: convertFromHourToSecond(regulationLimitGroup.hours),
  hoursWeekend: convertFromHourToSecond(regulationLimitGroup.hoursWeekend),
  distance: convertFromKmToM(regulationLimitGroup.distance),
  distanceWeekend: convertFromKmToM(regulationLimitGroup.distanceWeekend)
});
const convertDataFromServer = regulationLimitGroup => {
  let regulationLimits = regulationLimitGroup.regulationLimits || {};
  regulationLimits = regulationLimits.map(el => {
    return {
      ...el,
      hours: convertFromSecondToHour(el.hours),
      hoursWeekend: convertFromSecondToHour(el.hoursWeekend),
      distance: convertFromMToKm(el.distance),
      distanceWeekend: convertFromMToKm(el.distanceWeekend)
    };
  });
  return {
    ...regulationLimitGroup,
    hours: convertFromSecondToHour(regulationLimitGroup.hours),
    hoursWeekend: convertFromSecondToHour(regulationLimitGroup.hoursWeekend),
    distance: convertFromMToKm(regulationLimitGroup.distance),
    distanceWeekend: convertFromMToKm(regulationLimitGroup.distanceWeekend),
    regulationLimits
  };
};
const regulationLimitGroup = new CommonApi('regulationLimitGroup', 'регламент групп НТС', convertDataToServer, convertDataFromServer);
export default regulationLimitGroup;
